import React from "react";
import locale from "@bonliva-crm/locale";
import { Form } from "@components/formx";
import { Text } from "@components/formx_item_form";
import { CallListType, NodeRefFullInput, NodeType } from "@graphql";
import { CallListEditorStore } from "./CallListEditorStore";

export type CallListEditorProps = {
  id?: string;
  listType?: CallListType;
  node: NodeRefFullInput;
  type: NodeType;
  onClose: () => void;
  onAdded: () => void;
};

type Props = CallListEditorProps & {
  store: CallListEditorStore;
};

export function CallListEditor(props: Props) {
  return (
    <Form store={props.store}>
      <Text name="name" label={locale.Name} TextFieldProps={{ autoFocus: true }} />
    </Form>
  );
}
